import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

// A labelled logo picker shared by the group and school create surfaces. It reads the
// chosen image as a base64 string (identical mechanics to the old bare uploader) and
// hands it back via onFile; it also shows the filename and a small preview so operators
// can see what they picked. The caller owns where base64/fileName/truncated are stored.
// fileName can be null (not just undefined, so a default parameter is no guard) mid-upload:
// the Formik field updates fire from a FileReader callback, which React 17 does not batch,
// so the preview can render with the base64 set while the filename is still its initial null.
const mimeFor = (fileName) => (String(fileName || '').toLowerCase().endsWith('.png') ? 'image/png' : 'image/jpeg');

export default function LogoUpload({
  label = 'Logo',
  helperText = 'PNG or JPEG. Shown across the dashboards.',
  fileName,
  base64,
  onFile,
}) {
  const handleChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const imageName = file.name.split('.')[0];
    const truncated = imageName.length > 23 ? `${imageName.substr(0, 23)}...` : file.name;
    const reader = new FileReader();
    reader.onload = (readerEvt) => {
      onFile({ base64: btoa(readerEvt.target.result), fileName: file.name, truncated });
    };
    reader.readAsBinaryString(file);
  };

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{label}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>{helperText}</Typography>
      <Stack direction="row" spacing={2} alignItems="center">
        <Button variant="outlined" component="label" startIcon={<UploadFileIcon />}>
          Choose image
          <input type="file" hidden accept="image/png,image/jpeg" onChange={handleChange} />
        </Button>
        {base64 && (
          <Box
            component="img"
            src={`data:${mimeFor(fileName)};base64,${base64}`}
            alt="Logo preview"
            sx={{ width: 48, height: 48, objectFit: 'contain', border: '1px solid #e0e0e0', borderRadius: 1 }}
          />
        )}
        {fileName && (
          <Typography variant="body2" color="text.secondary">{fileName}</Typography>
        )}
      </Stack>
    </Box>
  );
}
